import { useContext, useEffect, useState } from "react";
import { fabric } from "@utils/fabric";
import ReactTooltip from "react-tooltip";
import { BiArrowToLeft, BiArrowToRight } from "react-icons/bi";
import { AppContext } from "../context/AppContext";
import LayerItem from "./LayerItem";
import LayersEmpty from "./LayersEmpty";
import { useTranslation } from "react-i18next";

const ICON_SIZE = 16;

function Layers({
  isLayerOpened = true,
  onLayerToggle = () => {},
}: {
  isLayerOpened: boolean;
  onLayerToggle: () => void;
}) {
  const { canvas, selectedObject, coreHandler } = useContext(AppContext);
  const [objects, setObjects] = useState<fabric.Object[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    function updateObjects() {
      let objects = canvas?.getObjects() || [];
      objects.reverse();
      setObjects(objects);
      ReactTooltip.rebuild();
    }

    if (canvas && coreHandler) {
      coreHandler?.eventHandler.on("object:added", () => {
        updateObjects();
      });

      coreHandler?.eventHandler.on("object:removed", () => {
        updateObjects();
      });

      coreHandler?.eventHandler.on("canvas:reorder", () => {
        updateObjects();
      });

      coreHandler?.eventHandler.on("design:loaded", () => {
        updateObjects();
      });
    }
  }, [canvas, coreHandler]);

  return (
    <div className="relative h-full divide-y overflow-auto border-r border-b">
      <div className={`flex items-center space-x-2 bg-white border-b border-gray-200 py-1.5 px-3 shadow-sm`}>
        <div className="flex items-center justify-center">
          <button
            className="rounded-lg p-2.5 text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900"
            onClick={() => {
              onLayerToggle();
            }}
          >
            {isLayerOpened && <BiArrowToLeft size={ICON_SIZE} />}
            {!isLayerOpened && <BiArrowToRight size={ICON_SIZE} />}
          </button>
          {isLayerOpened && (
            <p className="ml-1 text-sm font-medium text-gray-700">
              {t("layers_title")}
            </p>
          )}
        </div>
      </div>
      {objects.length === 0 && isLayerOpened && (
        <div className="flex h-[calc(100%-45px)] items-center justify-center">
          <LayersEmpty />
        </div>
      )}
      {objects.length !== 0 &&
        objects.map(function (object, index) {
          return (
            <LayerItem
              key={index}
              object={object}
              selected={selectedObject === object}
              isLayerOpened={isLayerOpened}
            />
          );
        })}
    </div>
  );
}

export default Layers;
